import { Button, ButtonGroup } from "@blueprintjs/core";
import React from "react";

/**
 * blueprint style paging component
 */

interface IPagingProps {
	maxVisible?: number;
	minimal?: boolean;
	small?: boolean;
	pageNumber: number;
	pageSize: number;
	setPageNumber: (pageNumber: number) => void;
	total: number;
}

export default class Paging extends React.PureComponent<IPagingProps> {

	public render() {
		const { minimal, small, pageNumber = 0, pageSize, total = 0 } = this.props;

		if (pageSize < 1 || total < 1) {
			return null;
		}

		const pages: number[] = [];

		for (let i = 0, len = Math.ceil(total / pageSize); i < len; i++) {
			pages.push(i);
		}

		// also don't show if only one page?
		if (pages.length < 2) {
			return null;
		}

		const prevDisabled = pageNumber < 1;
		const nextDisabled = pageNumber >= pages.length - 1;

		return (
			<ButtonGroup minimal={minimal}>
				<Button
					disabled={prevDisabled}
					onClick={this.setPageNumber(0)}
					icon="double-chevron-left"
					small={small}
				/>
				<Button
					disabled={prevDisabled}
					onClick={this.setPageNumber(pageNumber - 1)}
					icon="chevron-left"
					small={small}
				/>
				{
					this.getVisiblePageList(pages).map((n) => {

						return (
							<Button
								key={n}
								small={small}
								onClick={this.setPageNumber(n)}
								text={(n + 1).toString()}
								active={n === pageNumber}
							/>
						);
					})
				}
				<Button
					disabled={nextDisabled}
					onClick={this.setPageNumber(pageNumber + 1)}
					icon="chevron-right"
					small={small}
				/>
				<Button
					disabled={nextDisabled}
					onClick={this.setPageNumber(pages.length - 1)}
					icon="double-chevron-right"
					small={small}
				/>
			</ButtonGroup>
		);
	}

	private getVisiblePageList = (pages: number[]) => {
		const { maxVisible = 5, pageNumber = 0 } = this.props;

		// maximum visible pages
		const maxPages = maxVisible || 5;

		// if less pages than maximum, no overflow
		if (maxPages > pages.length) {
			return pages;
		}

		const padding: number = Math.floor(maxPages / 2);

		let start = pageNumber > padding ? pageNumber - padding : 0;
		let end = start + maxPages;

		if (end > (pages.length - padding + 1)) {
			end = pages.length;
			start = end - maxPages;
		}

		return pages.slice(start, end);
	}

	private setPageNumber = (n: number) => () => {
		const { setPageNumber } = this.props;
		setPageNumber(n);
	}
}



// WEBPACK FOOTER //
// ./src/core/components/Paging.tsx